<template>
  <div class="relative overflow-hidden">
    <router-view />
    <ModalController />
  </div>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import ModalController from "@/components/Modals/Assets/Controller.vue";
import { registerWebPushNotifications } from '@/assets/js/webPush';

const store = useStore();

const email = computed(() => store.state.user.email);

const initUserAccount = () => {
    store.commit("calendar/loadData");
    store.dispatch("calendar/innitGetUpcomingEvents");
};

const initGuestAccount = () => {
    store.dispatch("user/getLangGuest");
};

const initCloudOrOnPremise = () => {
    let onpremise = process.env.VUE_APP_BUILD_TYPE !== "cloud";
    store.commit("user/onpremise", onpremise);
};

onMounted(() => {
    initCloudOrOnPremise();
    if (email.value) initUserAccount();
    if (!email.value) initGuestAccount();
    store.dispatch("user/getUserInformation");
    store.dispatch("user/getLocation");
    store.dispatch("user/getConfiguration");
    store.commit("user/setTheme");
    store.commit("modals/resetState");
    store.dispatch('web3/initWeb3State');
});

watch(email, (value) => {
    if (value) {
        registerWebPushNotifications();
    }
}, { immediate: true });

</script>


